
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import Notifications from 'react-notification-system-redux';

class Notif extends React.Component {

  render() {
    const { notifications } = this.props;

    return (
      <Notifications
        notifications={notifications}
        //style={style}
      />
    );
  }
}

Notif.contextTypes = {
  store: PropTypes.object
};

Notif.propTypes = {
  notifications: PropTypes.array
};


export default connect(
  state => ({ notifications: state.notifications })
)(Notif);
